<template>
  <div v-if="show" class="modal-wrapper">
    <div class="custom-modal-overlay" @click.self="handleOverlayClick"></div>
    <div
      class="custom-modal"
      :class="{
        'modal-open': animateOpen && !animateClose,
        'modal-close': animateClose
      }"
    >
      <header class="modal-header">
        <h1 style="line-height: 1.2; color: black !important">
          {{ termLabel }}
        </h1>
        <button class="close-btn" @click="closeDialog">✕</button>
      </header>
      <div class="scroll-container" ref="scrollArea" @scroll="checkScrollEnd">
        <div v-if="term && term.text" v-html="term.text"></div>
        <div v-else>Nenhum termo encontrado</div>
      </div>
      <vz-button
        v-if="term && !term.accepted"
        :disabled="!canAccept"
        class="btn primary"
        @click="acceptTerm"
      >
        Concordo
      </vz-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VzButton from 'vsp-web-ui-lib/components/atoms/vz-button.vue';

export default {
  name: 'terms-dialog',
  components: { VzButton },
  data() {
    return {
      animateOpen: false,
      animateClose: false,
      canAccept: false
    };
  },

  computed: {
    ...mapState('terms', ['show', 'currentType', 'term']),

    termLabel() {
      return this.currentType === 'TERMS_OF_USE'
        ? 'TERMOS DE USO'
        : this.currentType === 'PRIVACY_POLICY'
        ? 'POLÍTICAS DE PRIVACIDADE'
        : 'NÃO DEFINIDO';
    }
  },

  watch: {
    show(val) {
      if (val) {
        this.animateClose = false;

        setTimeout(() => {
          this.animateOpen = true;
        }, 10);

        this.$nextTick(() => {
          this.checkIfScrollable();
        });
      }
    },

    term: {
      handler() {
        this.canAccept = false;
        this.checkIfScrollable();
      },
      deep: true
    }
  },

  mounted() {
    if (this.show) {
      this.animateOpen = true;
      this.animateClose = false;

      this.$nextTick(() => {
        this.checkIfScrollable();
      });
    }
  },

  methods: {
    handleOverlayClick() {
      if (this.term?.mandatory && !this.term?.accepted) {
        return;
      }
      this.closeDialog();
    },
    closeDialog() {
      this.animateOpen = false;
      this.animateClose = true;
      if (this.term?.mandatory && !this.term?.accepted) {
        this.$router.push('/logout')
      }
      setTimeout(() => {
        this.$store.dispatch('terms/closeTerms');
      }, 250);
    },

    acceptTerm() {
      this.$store.dispatch('terms/acceptTerm');
    },

    checkScrollEnd() {
      const el = this.$refs.scrollArea;
      const reachedEnd = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;

      if (reachedEnd) this.canAccept = true;
    },

    checkIfScrollable() {
      this.$nextTick(() => {
        const el = this.$refs.scrollArea;
        if (!el) return;

        if (el.scrollHeight <= el.clientHeight) {
          this.canAccept = true;
        }
      });
    }
  }
};
</script>

<style scoped>
.modal-wrapper {
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  color: black !important;
}

.custom-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(3px);
}

.custom-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  background: white;
  padding: 20px;
  width: 90%;
  max-width: 650px;
  max-height: 90vh;
  border-radius: 10px;
  opacity: 0;
  z-index: 10000;

  display: flex;
  flex-direction: column;
}

.modal-open {
  animation: modalFadeIn 0.25s forwards ease-out;
}

.modal-close {
  animation: modalFadeOut 0.25s forwards ease-in;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes modalFadeOut {
  from {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.scroll-container {
  max-height: 300px;
  overflow-y: auto;
  margin-top: 10px;
  padding-right: 10px;
}

@media (min-width: 1024px) {
  .scroll-container {
    max-height: 600px;
  }
}

.button-area {
  margin-top: 20px;
  display: flex;
  gap: 10px;
  justify-content: center;
}
</style>
